var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6926_1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3081 7.76562V8.86159C15.3809 9.39763 16.0042 10.0611 16.0042 10.7193C16.0042 12.2279 12.9691 13.413 9.96633 13.6628C9.69217 13.6853 9.48837 13.926 9.51128 14.1998C9.53279 14.4632 9.75987 14.6758 10.0483 14.6552C12.6622 14.44 17 13.3121 17 10.7193C17 9.3033 15.6144 8.32915 14.3081 7.76562Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50578 11.9717C5.22923 11.6903 4.74861 11.8279 4.66421 12.2144L4.44418 13.222C1.14803 12.3349 -0.434494 10.4268 2.69776 8.86159V7.76562C-1.41233 9.53867 -0.767355 12.8689 4.23141 14.1962L4.03355 15.1021C3.94872 15.4905 4.33364 15.8191 4.70489 15.6706L7.19426 14.6748C7.52357 14.5431 7.61381 14.1174 7.36452 13.8636L5.50578 11.9717Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72143 1.35769C8.5679 1.27067 8.37984 1.27147 8.22704 1.35969L4.19116 3.68978C4.87468 4.0844 8.13085 5.96436 8.50229 6.17882L12.8149 3.6773L8.72143 1.35769Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69339 9.21296C3.69339 9.39086 3.78829 9.55518 3.94232 9.64413L8.00508 11.9898V7.04211L3.69336 4.55273V9.21296H3.69339Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3124 9.21161V4.53906L9.00073 7.04009V11.9884L13.0635 9.64279C13.2176 9.55383 13.3124 9.38951 13.3124 9.21161Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6926_1509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPano);
export default __webpack_public_path__ + "static/media/pano.398f93eb7d777a539cfe36f34e0fea63.svg";
export { ForwardRef as ReactComponent };